var error = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof vimeography_pro !== "undefined") return resolve();
	__webpack_require__.l("", (event) => {
		if(typeof vimeography_pro !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		error.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		error.name = 'ScriptExternalLoadError';
		error.type = errorType;
		error.request = realSrc;
		reject(error);
	}, "vimeography_pro");
}).then(() => vimeography_pro);